<template>
  <div
    class="my-body py-20 text-white flex flex-wrap  md:pt-0 items-center px-8 sm:px-20 lg:px-40 xl:px-48"
  >
    <div
      v-for="(resource, i) in resources"
      :key="i"
      class="w-full md:w-1/3 mt-20 text-center mx-auto"
    >
      <div class="">
        <img class="text-center mx-auto h-12" :src="resource.image" />
        <main class="text-grey">
          <span class="block mt-3 text-lg font-bold">{{ resource.name }}</span>
          <span class="text-xs negative-top">{{ resource.caption }}</span>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    lbutton: () => import("@/components/general/button"),
  },
  data() {
    return {
      resources: [
        {
          name: "Easy-To-Use",
          image:
            "https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/home-screen/easy.png", width: "100%", height: "100%",
          caption: "Excellent user experience",
        },
        {
          name: "Expert Instructors",
          image:
            "https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/home-screen/instructor.png", width: "100%", height: "100%",
          caption:
            "Learn from industry experts who are passionate about teaching",
        },
        {
          name: "Learn Anywhere",
          image:
            "https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/home-screen/anywhere.png", width: "100%", height: "100%",
          caption: "Switch between your computer, tablet, or mobile device.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.my-body {
  background: #f5fbff;
}

.text-grey {
  color: #5c5c5c;
}

.negative-top {
  margin-top: -0.5em;
}
</style>
